import { css } from 'lit';
export const WalletManagerRouteStyle = css `
  :host {
    width: 100%;
    height: 100%;
  }

  .route-container {
    width: 100%;
    height: 100%;
  }
`;
//# sourceMappingURL=wallet-manager-route.style.js.map